import { render, staticRenderFns } from "./announcementDetail.vue?vue&type=template&id=5115043b&scoped=true&"
import script from "./announcementDetail.vue?vue&type=script&lang=js&"
export * from "./announcementDetail.vue?vue&type=script&lang=js&"
import style0 from "./announcementDetail.vue?vue&type=style&index=0&id=5115043b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115043b",
  null
  
)

export default component.exports